import { Box, Button, Typography } from '@mui/material'
import { COLORS } from 'const'
import { FUNCTIONALITIES_DATA_CONST } from 'const/functionalities.const'
import { motion } from 'framer-motion'
import { containerVariants, landingButtonPrimary, normalTextStyle, titleTextStyle } from 'styles'

export const FunctionalitiesSection = () => {
  return (
    <Box
      id="functionalities"
      sx={{
        py: { md: 10, xs: 5 },
        backgroundColor: '#ecf5feff',
        borderRadius: '50px 50px 0 0',
        mt: { md: -10, xs: -5 },
      }}
    >
      <Typography
        variant="h3"
        sx={{
          ...titleTextStyle,
          fontWeight: 800,
          textAlign: 'center',
          fontSize: { xs: '2.5rem', md: '3.5rem' },
          pb: { lg: 2 },
          color: COLORS.text.alt,
        }}
      >
        Funcionalidades
      </Typography>

      <Box
        component={motion.div}
        initial="offscreen"
        whileInView="onscreen"
        variants={containerVariants}
        viewport={{ once: true }}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'center',
          m: 5,
          mx: { xs: 5, md: 10, lg: 15 },
        }}
      >
        {FUNCTIONALITIES_DATA_CONST.map((item) => {
          const isReversed = item.id % 2 !== 0

          return (
            <Box
              key={item.id}
              component={motion.div}
              initial="offscreen"
              whileInView="onscreen"
              variants={containerVariants}
              viewport={{ once: true }}
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: isReversed ? 'row-reverse' : 'row' },
                alignItems: 'center',
                gap: 2,
                justifyContent: 'space-between',
                px: { md: 5 },
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  justifyContent: 'flex-end',
                  alignItems: 'flex-end',
                  position: 'relative',
                  zIndex: 10,
                  my: { lg: -6 },
                }}
              >
                <Box
                  component="img"
                  src={item.image}
                  alt={item.title}
                  sx={{
                    width: '100%',
                    minWidth: '90%',
                    maxHeight: { xs: 450, lg: 800 },
                    aspectRatio: '1 / 1',
                    objectFit: 'contain',
                    top: 0,
                    right: 0,
                    alignSelf: 'flex-end',
                  }}
                />
              </Box>

              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  position: 'relative',
                  zIndex: 20,
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    ...normalTextStyle,
                    fontWeight: 600,
                    fontSize: { xs: '2.2rem', md: '2.8rem' },
                    maxWidth: '400px',
                    px: { xs: 2, md: 0 },
                    pb: { md: 4 },
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  sx={{
                    ...normalTextStyle,
                    lineHeight: 1.4,
                    fontFamily: 'Poppins',
                    fontSize: { xs: '1.2rem', md: '1.2rem' },
                    maxWidth: '100%',
                    px: { xs: 2, md: 0 },
                  }}
                >
                  {item.description}
                </Typography>
                {item.description2 && (
                  <Typography
                    sx={{
                      ...normalTextStyle,
                      lineHeight: 1.4,
                      fontFamily: 'Poppins',
                      fontSize: { xs: '1.2rem', md: '1.2rem' },
                      maxWidth: '90%',
                      px: { xs: 2, md: 0 },
                    }}
                  >
                    {item.description2}
                  </Typography>
                )}
                {item.bullets.length > 0 && (
                  <Box
                    sx={{
                      display: 'grid',
                      gridTemplateColumns: item.bullets.length > 2 ? 'repeat(2, 1fr)' : '1fr',
                      gap: 1,
                      pt: 2,
                    }}
                  >
                    {item.bullets.map((bullet: string) => (
                      <Typography
                        key={bullet}
                        sx={{
                          ...normalTextStyle,
                          fontFamily: 'Poppins',
                          fontSize: { xs: '0.8rem', md: '1rem' },
                        }}
                      >
                        • {bullet}
                      </Typography>
                    ))}
                  </Box>
                )}

                <Button
                  variant="contained"
                  sx={{
                    ...landingButtonPrimary,
                    width: 'fit-content',
                    mt: 2,
                  }}
                  onClick={() => {
                    window.open(
                      process.env.REACT_APP_NUNA_PROCESS_ONBOARDING ?? item.buttonLink,
                      '_blank'
                    )
                  }}
                >
                  {item.buttonText}
                </Button>
              </Box>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
